import React, { useMemo } from "react";
import { Home } from "../pages/Home";
import { UsersList } from "../pages/Users";
import { PrivateRoute } from "./privateRoute";
import { Dashboard } from "../pages/Dashboard";
import { ClientsList } from "../pages/Clients";
import { SettingsList } from "../pages/Settings";
import { UserTypesList } from "../pages/UserTypes";
import { MessageModels } from "../pages/MessageModels";
import { IntegrationsList } from "../pages/Integrations";
import { ReservationsList } from "../pages/Reservations";
import { GeneralSettings } from "../pages/GeneralSettings";
import { AccommodationsList } from "../pages/Accommodations";
import { NotificationRulesList } from "../pages/NotificationRules";
import { Routes as Switch, Route, Navigate } from "react-router-dom";
import { AccommodationTypesList } from "../pages/AccommodationTypes";
import { NotificationsHistory } from "../pages/NotificationsHistory";
import { CompanyData } from "../pages/CompanyData";
import GuestPdf from "../pages/GuestPdf";
import { Points } from "../pages/Points";
import { SmartlocksList } from "../pages/MagikeiSmartlocks";
import { Profile } from "../pages/Profile";
import { Subscription } from "../pages/Subscription";
import { useGlobal } from "../hooks/global";
import { useApi } from "../hooks/api";
import { NotificationRulesListRoot } from "../pages/ROOT/NotificationRules";
import { MessageModelsRoot } from "../pages/ROOT/MessageModels";
import ContractReservationPdf from "../pages/ContractReservationPdf";

export const AppRoutes: React.FC = () => {
  const { isActiveActions, business } = useGlobal();
  const { user } = useApi();

  const activeActions = useMemo(() => isActiveActions(business?.subscriptions?.situation), [isActiveActions, business?.subscriptions?.situation]);

  return (
    <Switch>
      <Route path="" element={<PrivateRoute />}>
        {activeActions ? <Route index element={<Dashboard />} /> : <Route index element={<Home />} />}
      </Route>

      <Route path="dashboard" element={<PrivateRoute />}>
        <Route index element={<Dashboard />} />
      </Route>

      <Route path="points" element={<PrivateRoute />}>
        <Route index element={<Points />} />
      </Route>

      <Route path="clients-app" element={<PrivateRoute />}>
        <Route index element={<ClientsList />} />
      </Route>

      <Route path="accommodations" element={<PrivateRoute />}>
        <Route index element={<AccommodationsList />} />
        <Route path="accommodations-types" element={<AccommodationTypesList />} />
        <Route path="magikey-smartlocks" element={<SmartlocksList />} />
      </Route>

      <Route path="reservations" element={<PrivateRoute />}>
        <Route index element={<ReservationsList />} />
      </Route>

      <Route path="messaging" element={<PrivateRoute />}>
        <Route index element={<Navigate to="/" />} />
        <Route path="message-models" element={<MessageModels />} />
        <Route path="notification-rules" element={<NotificationRulesList />} />
        <Route path="notifications-history" element={<NotificationsHistory />} />
      </Route>

      <Route path="users" element={<PrivateRoute />}>
        <Route index element={<UsersList />} />
        <Route path="users-types" element={<UserTypesList />} />
      </Route>

      {user?.user_type?.name === 'ADMINISTRADOR' && (
        <Route path="subscription" element={<PrivateRoute />}>
          <Route index element={<Subscription />} />
        </Route>
      )}

      <Route path="mobile-app" element={<SettingsList />} />

      <Route path="settings" element={<PrivateRoute />}>
        <Route index element={<GeneralSettings />} />
        <Route path="notification-rules-default" element={<NotificationRulesListRoot />} />
        <Route path="message-models-default" element={<MessageModelsRoot />} />
        <Route path="company-data" element={<CompanyData />} />
        <Route path="perfil" element={<Profile />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Route>

      <Route path="integrations" element={<PrivateRoute />}>
        <Route index element={<IntegrationsList />} />
      </Route>

      <Route path="message-models" element={<PrivateRoute />}>
        <Route index element={<MessageModels />} />
      </Route>

      <Route path="guest-registration-pdf" element={<GuestPdf />} />

      <Route path="contract-reservation" element={<ContractReservationPdf />} />

      <Route path="*" element={<Navigate to="" />} />
    </Switch>
  );
};
